import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loader-icon',
    templateUrl: './loader-icon.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoaderIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
